var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner-box2" }, [
      _c("div", { staticClass: "container banner-content2" }, [
        _c("h3", { staticClass: "banner1-title" }, [_vm._v("易安捷商业服务")]),
        _c("p", { staticClass: "banner1-text" }, [
          _vm._v("易安捷SaaS系统集成HRM、CRM、FMS、OMS、WMS等各"),
          _c("br"),
          _vm._v("类系统，为用户开发提供更多针对性的产品和服务，让企业运"),
          _c("br"),
          _vm._v("营更高效、更快速、更简单。")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-570b6712", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-570b6712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/services/banner.vue
// module id = fd3C
// module chunks = 8 9 10 11 12 13 14 15 16 17 18 19